import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import React from 'react'

interface Props {
  state: boolean
  children: React.ReactNode
  className?: string
  loaderClassName?: string
}

export default function Index({ state, children, className, loaderClassName }: Props) {
  return (
    <React.Fragment>
      {state ? (
        <Container className={`bg-[#FFFFFF50] w-full h-full absolute z-50 top-0 left-0 flex items-center justify-center ${className}`}>
          <div className={`custom-loader w-[30px] h-[30px] rounded-full border-[5px] border-r-[#ffffff] ${loaderClassName ? loaderClassName : 'border-[#ddd]'}`}></div>
        </Container>
      ) : null}
      {children}
    </React.Fragment>
  )
}

const Container = styled(motion.div)`
  .custom-loader {
    animation: s2 1s infinite linear;
  }
  @keyframes s2 {
    to {
      transform: rotate(1turn);
    }
  }
`
